<template>
  <div class="book-detail">
    <div class="nav">
      <img
        src="https://portal-minio.pass.lygtc.edu.cn/cms/%E9%A1%B6%E9%83%A8%E5%AF%BC%E8%88%AA%E6%A0%8Flogo-1607933659282.png"
        alt=""
      />
      <span class="ml">|</span>
      <span>图书查询信息</span>
    </div>
    <div class="book-content">
      <div class="title">图书查询信息</div>
      <div class="book-form">
        <el-card class="box-card">
          <el-form :inline="true" :model="bookInfo" class="demo-form-inline">
            <el-form-item label="输入图书名称查询：">
              <el-input
                v-model="bookInfo.name"
                placeholder="图书名称"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearchBook(bookInfo.name)"
                >查询</el-button
              >
              <el-button @click="onReset">重置</el-button>
            </el-form-item>
          </el-form>
          <div class="el-table-style">
            <div class="el-table-user">
              <el-table
                ref="singleTable"
                :data="booksData"
                highlight-current-row
                @current-change="handleCurrentChange"
                style="width: 100%"
                border
                height="calc(100vh - 320px)"
              >
                <el-table-column
                  type="index"
                  width="50"
                  label="序号"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="userName" label="学号" align="center">
                </el-table-column>
                <el-table-column
                  prop="barcode"
                  label="借书号"
                  sortable
                  align="center"
                ></el-table-column>
                <el-table-column prop="title" label="图书名" align="center">
                </el-table-column>
                <el-table-column
                  prop="borrowDate"
                  label="借书日期"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="returnDate"
                  label="应还日期"
                  align="center"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { getBookList } from '@/api/lianyungang.js';
export default {
  data() {
    return {
      // 当前页
      currentPage: 1,
      // 一页显示多少条
      pageSize: 10,
      // 总页数
      totalSize: 100,
      bookInfo: {
        name: '',
      },
      booksData: [],
      saveData: [],
      // 地址参数
      userName: '',
    };
  },
  mounted() {
    this.fetchUrlInfo();
    this.fetchBookList();
  },
  methods: {
    // 获取地址栏上的参数
    fetchUrlInfo() {
      let urlInfo = window.location.href;
      this.userName = urlInfo.split('?')[1];
    },
    fetchBookList() {
      let data = {
        userName: this.userName,
      };
      getBookList(data).then((res) => {
        this.booksData = res.data.data;
        this.saveData = res.data.data;
      });
    },
    // 模糊查询
    onSearchBook(val) {
      if (val.trim() && this.saveData) {
        let arr = [];
        this.saveData.forEach((item) => {
          if (item.title.indexOf(val) !== -1) {
            arr.push(item);
          }
        });
        this.booksData = arr;
      }
      this.bookInfo.name = '';
    },
    handleSizeChange(val) {
      console.log(`当前页: ${val}`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    onReset() {
      this.fetchBookList();
    },
  },
};
</script>

<style lang="scss" scoped>
.book-detail {
  .nav {
    display: flex;
    align-items: center;
    padding: 0 60px;
    height: 60px;
    width: 100%;
    height: 60px;
    background: rgb(57, 131, 218);
    color: #fff;
    .ml {
      margin-left: 4px;
      margin-right: 4px;
    }
    img {
      margin-top: 4px;
      vertical-align: middle;
    }
  }
  .book-content {
    margin: 0 60px;
    .title {
      margin: 20px 0;
      color: rgb(57, 131, 218);
    }
    /deep/.el-form {
      display: flex;
      justify-content: flex-end;
    }
  }
  /deep/.el-pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
  /deep/.el-table .cell {
    white-space: pre-line !important;
  }
  .el-table-style {
    width: 100%;
    // height: calc(100vh - 320px);
  }
  .el-table-user {
    max-height: 100%;
    overflow-y: auto;
  }
}
</style>